/* eslint-disable react/no-unescaped-entities */
"use client"
import { Button } from "@mui/material";
import { usePathname, useRouter } from "next/navigation";

export default function Custom404() {

  const router = useRouter();
  const pathname = usePathname();

  return (
    <>
      <section className="error_page text_center u_spc">
        <div className="container">
          <h1>404</h1>
          <h2 className="hd_4">OOPS! Page not found</h2>
          <p>We couldn't find that page, but check out our homepage or <br /> search for something else.</p>
          <div className="mt_30">
            <Button
              onClick={() => {
                if (pathname.startsWith("/cso")) {
                  router.push("/cso/dashboard");
                } else if (pathname.startsWith("/evaluator")) {
                  router.push("/evaluator/dashboard");
                } else if (pathname.startsWith("/supervisor")) {
                  router.push("/supervisor/dashboard");
                } else if (pathname.startsWith("/mall-manager")) {
                  router.push("/mall-manager/dashboard");
                } else if (pathname.startsWith("/qa")) {
                  router.push("/qa/dashboard");
                } else if (pathname.startsWith("/cs-manager")) {
                  router.push("/cs-manager/dashboard");
                } else {
                  router.push("/");
                }
              }}
            >
              GO TO Dashbaoard
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}